import { Radio, Select, Skeleton } from "antd"
import { OfficeDutyLocationsEntity } from "../typings"

export interface DutyLocationItem {
  id: number | "workplace"
  name: string
  addressLine1?: string
}

const SelectDutyLocationWrapper = ({
  isLoadingDutyLocation,
  selectedLocation,
  setSelectedLocation,
  dutyLocation,
}: {
  isLoadingDutyLocation: boolean
  selectedLocation: number | "workplace"
  setSelectedLocation: (value: number | "workplace") => void
  dutyLocation: (DutyLocationItem | null)[]
}) => {
  return (
    <div className="border border-slate-300 rounded-md py-2 px-4">
      <p className="text-slate-500 text-sm font-medium">
        Select duty location to configure
      </p>
      {isLoadingDutyLocation ? (
        <Skeleton
          className="mt-3"
          active
          title={false}
          paragraph={{ rows: 1, width: "100%" }}
        />
      ) : (
        <Select
          className="[&_.ant-select-selector]:!p-0 [&_.ant-select-selection-item]:font-bold [&_.ant-select-selection-item]:text-slate-900"
          value={selectedLocation ?? "workplace"}
          onChange={(value) => setSelectedLocation(value)}
          suffixIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>
          }
          bordered={false}
          style={{ width: "100%", margin: "0px" }}
          optionLabelProp="label"
        >
          {dutyLocation?.map((item: any) => (
            <Select.Option
              key={item?.id}
              value={item?.id}
              label={
                <p className="font-bold text-base capitalize">{item?.name}</p>
              }
            >
              <OptionLabel
                title={item?.name}
                subtitle={item?.addressLine1}
                selectedValue={selectedLocation}
                optionId={item?.id}
              />
            </Select.Option>
          ))}
        </Select>
      )}
    </div>
  )
}

export default SelectDutyLocationWrapper

const OptionLabel = ({
  title,
  subtitle,
  showRadio = true,
  selectedValue,
  optionId,
}: {
  title: string
  subtitle: string
  showRadio?: boolean
  selectedValue: any
  optionId?: any
}) => (
  <div className="flex items-center justify-between w-full">
    <div className="flex flex-col">
      {optionId === "workplace" && (
        <span className="text-xs text-gray-400 truncate">
          Primary duty location
        </span>
      )}
      <span className="font-bold capitalize">{title}</span>
      <span className="text-xs text-gray-400 truncate">{subtitle}</span>
    </div>

    {showRadio && (
      <Radio checked={String(selectedValue) === String(optionId)} />
    )}
  </div>
)
